import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError as observableThrowError } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { LoggingService } from '../../shared/services/logging/logging.service';

@Injectable()
export class CustomerService extends BaseApiService {

    private customerIdSubject = new BehaviorSubject<number>(0);
    currentCustomerId = this.customerIdSubject.asObservable();

    constructor(private _loggingService: LoggingService) {
        super();
    }

    getCustomer(customerNumberId: number) {
        return this.get('Customer/' + customerNumberId);
    }

    getBasicCustomers(customerNumberIds: number[]) {
        return this.post('TitleRegistration/Ownership/Customers/Basic', customerNumberIds);
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            return observableThrowError(error.error);
        } else {
            return observableThrowError('Server error');
        }
    }

    private replacer(key, value) {
        if (value === '') {
            return undefined;
        }

        return value;
    }

    setCurrentSelectedCustomerId(selectedCustomerId: any){
        this.customerIdSubject.next(selectedCustomerId);
    }
}
